import instance from "@/services/api";

export const contractsDictionaryAPI = {
  async read1cStatus(params) {
    return await instance()
      .get("/handbook/contractor_agreement_list/1c_status/read/", { params })
      .then((res) => res?.data);
  },
  async readResidents() {
    return await instance()
      .get("/handbook/contractor_agreement_list/1c_status/residents/")
      .then((res) => res?.data);
  },
  async readContractors() {
    return await instance()
      .get("/handbook/contractor_agreement_list/1c_status/contractors/")
      .then((res) => res?.data);
  },
};
